import { render, staticRenderFns } from "./IconMenuInternetMovil.vue?vue&type=template&id=2cfe2c39&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports